import aiicon from "../images/ai_icon.svg";
import blicon from "../images/blockchain_icon.svg";
import vricon from "../images/virtual_reality.svg";
import ccicon from "../images/cloud_computing.svg";
import ioticon from "../images/iot_icon.svg";
import hlicon from "../images/health_icon.svg";

export const trackData = [
  {
    title: "AI / ML",
    paragraph: "Say Hello to the Future",
    image: aiicon,
  },
  {
    title: "AR / VR",
    paragraph: "Get transported to new worlds through VR",
    image: vricon,
  },
  {
    title: "Block Chain",
    paragraph: "Building Blocks for a Better World",
    image: blicon,
  },
  {
    title: "Cloud Computing",
    paragraph: "See you on the cloud ",
    image: ccicon,
  },
  {
    title: "Internet Of Things",
    paragraph: "A home for things",
    image: ioticon,
  },
  {
    title: "Health Care",
    paragraph: "For the Health of It",
    image: hlicon,
  },
];
